import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { UserNotification } from '@app/model/userNotification';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService implements OnDestroy {
  private readonly baseUrl = `${environment.apiUrl}notifications`;

  constructor(private http: HttpClient) {}

  createUserNotification(
    notification: UserNotification,
  ): Observable<UserNotification> {
    return this.http.post<UserNotification>(`${this.baseUrl}`, notification);
  }

  getAllUserNotifications(): Observable<UserNotification[]> {
    return this.http.get<UserNotification[]>(`${this.baseUrl}`);
  }

  getAllUserNotificationsPaginated(
    limit = 1000,
    pageNumber = 1,
  ): Observable<UserNotification[]> {
    return this.http.get<UserNotification[]>(`${this.baseUrl}/paginated`, {
      params: { limit: limit.toString(), pageNumber: pageNumber.toString() },
    });
  }

  getUserNotificationsByUser(
    limit = 1000,
    pageNumber = 1,
  ): Observable<UserNotification[]> {
    return this.http.get<UserNotification[]>(`${this.baseUrl}/user`, {
      params: { limit: limit.toString(), pageNumber: pageNumber.toString() },
    });
  }

  updateUserNotification(
    id: string,
    notification: UserNotification,
  ): Observable<UserNotification> {
    return this.http.put<UserNotification>(
      `${this.baseUrl}/${id}`,
      notification,
    );
  }

  getUserNotificationById(id: string): Observable<UserNotification> {
    return this.http.get<UserNotification>(`${this.baseUrl}/${id}`);
  }

  ngOnDestroy(): void {}
}
